import React from 'react';
import FormSwiftModal from 'DesignSystem/FormSwiftModal';
import ModalHeader from 'DesignSystem/FormSwiftModal/ModalHeader';
import ModalBody from 'DesignSystem/FormSwiftModal/ModalBody';
import PropTypes from 'prop-types';

const SecondActionModal = ({
  closeStaticSecondActionModal: handleCloseStaticSecondActionModal,
  isSecondActionModalOpen,
  shareUrl,
  signUrl,
}) => {
  const headerCopy = 'Success! Next, do you need to send your document to someone?';

  const handleShareClick = () => {
    window._track('Main CTA | Second Action Modal | Static-Builder-Member', 'Share');
    window.COOKIE.set('secondaryActionClicked', 'share');
  };

  const handleCreateClick = () => {
    window._track('Share Variation | Secondary CTA | Second Action Modal | Static-Builder-Member', 'Create');
    window.COOKIE.set('secondaryActionClicked', 'create');
  };

  const handleUploadClick = () => {
    window._track('Share Variation | Secondary CTA | Second Action Modal | Static-Builder-Member', 'Upload');
    window.COOKIE.set('secondaryActionClicked', 'upload');
  };

  const handleSignClick = () => {
    window._track('Share Variation | Secondary CTA | Second Action Modal | Static-Builder-Member', 'Sign');
    window.COOKIE.set('secondaryActionClicked', 'sign');
  };


  return (
    <FormSwiftModal
      className="onboarding-second-action-modal"
      isOpen={isSecondActionModalOpen}
      handleCloseModal={handleCloseStaticSecondActionModal}
      onAfterOpen={() => window.Upload.activateUploadButtonById('uploadSecondAction')}
    >
      <ModalHeader headerCopy={headerCopy} />
      <ModalBody>
        <a
          className="btn btn-success onboarding-modal-main-cta-button"
          href={shareUrl}
          onClick={handleShareClick}
        >
          Yes, Share Document
        </a>
        <div className="onboarding-modal-footer">
          <div className="onboarding-try-block">Or try one of these:</div>
          <div className="onboarding-modal-secondary-action-wrapper">
            <div className="onboarding-modal-secondary-action-block">
              <div className="image-wrapper">
                <img
                  alt="Start a new document"
                  src="/images/builder-static/new-doc.png"
                />
              </div>
              <a
                className="onboarding-modal-secondary-action"
                data-ctatype="create"
                href="/document-library"
                onClick={handleCreateClick}
              >
                Start a New Document &gt;
              </a>
            </div>
            <div className="onboarding-modal-secondary-action-block">
              <div className="image-wrapper">
                <img
                  alt="Upload your PDF"
                  src="/images/builder-static/edit-pdf.png"
                />
              </div>
              <a
                className="onboarding-modal-secondary-action"
                data-ctatype="upload"
                id="uploadSecondAction"
                onClick={handleUploadClick}
              >
                Upload Your PDF &gt;
              </a>
            </div>
            <div className="onboarding-modal-secondary-action-block">
              <div className="image-wrapper">
                <img
                  alt="Sign your document"
                  src="/images/builder-static/signature.png"
                />
              </div>
              <a
                className="onboarding-modal-secondary-action"
                data-ctatype="sign"
                href={signUrl}
                onClick={handleSignClick}
              >
                Sign Your Document &gt;
              </a>
            </div>
          </div>
          <a
            className="onboarding-modal-return-button"
            href="/my-documents"
            onClick={() => window._track('Share Variation | Second Action Modal | Static-Builder-Member', 'My Documents')}
          >
            Return to Recent Documents &gt;
          </a>
        </div>
      </ModalBody>
    </FormSwiftModal>
  );
};

SecondActionModal.propTypes = {
  closeStaticSecondActionModal: PropTypes.func.isRequired,
  isSecondActionModalOpen: PropTypes.bool.isRequired,
  shareUrl: PropTypes.string.isRequired,
  signUrl: PropTypes.string.isRequired,
};

export default SecondActionModal;



// WEBPACK FOOTER //
// ./src-react/StaticBuilderModals/SecondActionModal/SecondActionModalV1.jsx